import { ConfigurationProfilesGzDataProvider } from '../dataProvider/ConfigurationProfilesGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class ConfigurationProfilesDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ConfigurationProfilesGzDataProvider);
  }
}
